import React, { Fragment, useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import axiosInstance from "../../utils/axios";
import { useSelector } from "react-redux";
import { errorToast } from "../../shared/Toast";

const AddPromotion = () => {
    const navigate = useNavigate();
    const userType = localStorage.getItem("userType");
    const merchantIdFromStorage = localStorage.getItem("MerchantId");
    const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
    const selectedMerchant = userType === "merchant" ? merchantIdFromStorage : reduxSelectedMerchant;

    const [isFetching, setIsFetching] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [promotionData, setPromotionData] = useState({
        promotionName: "",
        description: "",
        startDate: "",
        endDate: "",
    });
    const [imageForPayload, setImageForPayload] = useState(null);
    const [dummyImg, setDummyImg] = useState("https://via.placeholder.com/50");

    const handleInputChange = (e, key) => {
        setPromotionData((prev) => ({ ...prev, [key]: e.target.value }));
    };

    const _handleImgChange = (e) => {
        e.preventDefault();
        const image = e.target.files[0];
        setImageForPayload(image);
        let reader = new FileReader();
        reader.onload = () => setDummyImg(reader.result);
        reader.readAsDataURL(image);
    };

    const handleDiscard = () => {
        setPromotionData({ promotionName: "", description: "", startDate: "", endDate: "" });
        setImageForPayload(null);
        setDummyImg("https://via.placeholder.com/50");
    };

    const handleValidSubmit = async (e) => {
        e.preventDefault();
        if (!imageForPayload) {
            setImageError(true);
            return;
        }
        if (!selectedMerchant || selectedMerchant === 'all') {
            errorToast("Please select a merchant.");
            return;
        }
        setImageError(false);
        setIsFetching(true);
        try {
            const formData = new FormData();
            formData.append("promotionName", promotionData.promotionName);
            formData.append("description", promotionData.description);
            formData.append("startDate", promotionData.startDate);
            formData.append("endDate", promotionData.endDate);
            formData.append("merchantID", selectedMerchant);
            formData.append("dataType", "promotion");
            if (imageForPayload) formData.append("image1", imageForPayload);

            const response = await axiosInstance.post("/api/promotion/createPromotion", formData, { rawRequest: true });

            if (response.status === 200 && !response.data.error) {
                navigate("/promotion/promotion-list");
            } else {
                console.error("Error adding promotion:", response.data.message);
            }
        } catch (error) {
            console.error("Error adding promotion:", error.response?.data || error);
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <Fragment>
            <Breadcrumb title="Add Promotion" parent="Promotions" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Add Promotion</h5>
                            </CardHeader>
                            <CardBody>
                                {isFetching ? (
                                    <div>Creating promotion...</div>
                                ) : (
                                    <Row className="product-adding">
                                        <Col xl="5">
                                            <div className="add-product">
                                                <Input type="file" className="upload" onChange={_handleImgChange} required />
                                                {imageError && <div style={{ color: 'red', fontSize: '0.9rem' }}>Image is required</div>}
                                                <img src={dummyImg} alt="promotion" style={{ width: 50, height: 50 }} />
                                            </div>
                                        </Col>
                                        <Col xl="7">
                                            <Form className="needs-validation" onSubmit={handleValidSubmit}>
                                                <FormGroup className="form-group mb-3 row">
                                                    <Label className="col-xl-3 col-sm-4 mb-0">Name:</Label>
                                                    <div className="col-xl-8 col-sm-7">
                                                        <Input
                                                            type="text"
                                                            value={promotionData.promotionName}
                                                            onChange={(e) => handleInputChange(e, "promotionName")}
                                                            required
                                                        />
                                                    </div>
                                                </FormGroup>
                                                <FormGroup className="form-group mb-3 row">
                                                    <Label className="col-xl-3 col-sm-4 mb-0">Description:</Label>
                                                    <div className="col-xl-8 col-sm-7">
                                                        <Input
                                                            type="textarea"
                                                            value={promotionData.description}
                                                            onChange={(e) => handleInputChange(e, "description")}
                                                        />
                                                    </div>
                                                </FormGroup>
                                                <FormGroup className="form-group mb-3 row">
                                                    <Label className="col-xl-3 col-sm-4 mb-0">Start Date:</Label>
                                                    <div className="col-xl-8 col-sm-7">
                                                        <Input
                                                            type="date"
                                                            value={promotionData.startDate}
                                                            onChange={(e) => handleInputChange(e, "startDate")}
                                                            required
                                                        />
                                                    </div>
                                                </FormGroup>
                                                <FormGroup className="form-group mb-3 row">
                                                    <Label className="col-xl-3 col-sm-4 mb-0">End Date:</Label>
                                                    <div className="col-xl-8 col-sm-7">
                                                        <Input
                                                            type="date"
                                                            disabled={!promotionData.startDate}
                                                            value={promotionData.endDate}
                                                            onChange={(e) => handleInputChange(e, "endDate")}
                                                            min={promotionData.startDate || ""}
                                                            required
                                                        />
                                                    </div>
                                                </FormGroup>
                                                <div className="offset-xl-3 offset-sm-4 d-flex gap-2">
                                                    <Button color="primary" type="submit">
                                                        Add
                                                    </Button>
                                                    <Button color="danger" onClick={handleDiscard}>
                                                        Discard
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Col>
                                    </Row>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default AddPromotion;